import { triggerFadeInExpandCollapseStatefulAnimation } from '../../../core/animations';

export const AreasByProvinceComponentAnimations = [triggerFadeInExpandCollapseStatefulAnimation('animatedContent')];
